import React from 'react';
import './ModalBase.css';
import { FaTimes } from 'react-icons/fa';

/**
 * Модальное окно «Отменить редактирование»
 * Использует те же стили, что и DeleteConfirmationModal
 */
export default function CancelEditingModal({ onClose, onConfirm }) {
  return (
    <div className="modal-overlay">
      <div className="modal-window">
        {/* Кнопка закрытия */}
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Заголовок */}
        <h2 className="modal-title">Отменить редактирование?</h2>

        {/* Текст */}
        <div className="modal-form">
          <p className="modal-delete-text">
            Вы уверены, что хотите отменить редактирование?<br />
            Несохраненные данные будут удалены.
          </p>
        </div>

        {/* Действия */}
        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>
            Назад
          </button>
          <button className="modal-button save" onClick={onConfirm}>
            Продолжить
          </button>
        </div>
      </div>
    </div>
  );
}
